import { ColDef } from 'ag-grid-community';

export const hiddenSearchableColumn: Partial<ColDef> = {
  hide: true,
  filter: true,
};
